<template>
    <div
        v-if="result?.listings?.length > 0"
        class="md-house layout11 mg-bg"
        ref="houseLayout11"
        :style="{ ...spaceStyle, ...colorStyle}"
    >
        <div class="house-container" :class="layout11Fixed">
            <div v-if="(title || desc) && isMobile" class="house-title f-col">
                <site-title :title="title" />
                <site-sub-title class="desc" :title="desc" />
            </div>
            <div class="house-list" :class="['len-' + result.listings.length]">
                <Swiper
                    class="pc-swiper"
                    v-bind="swiperOption"
                    @init="onSwiperReady"
                    v-if="!isMobile"
                >
                    <Slide
                        v-for="(item, index) in result.listings"
                        :key="index"
                        :class="{ 'f-pl': !isMobile }"
                        :style="{ background: bgColor }"
                    >
                        <house :house="item" :title="title" />
                    </Slide>
                </Swiper>
                <template v-else>
                    <div class="mobile-list" :class="{'f-col': isMobile}">
                        <house :house="item" v-for="(item, index) in result.listings" :key="index" />
                    </div>
                </template>
            </div>
            <div
                class="btn-wrap"
                v-if="result.listings.length > 1 && moreShow && moreText"
                :style="{ background: bgColor2 }"
            >
                <site-button
                    v-if="moreShow && moreText"
                    type="plain"
                    :html="moreText"
                    class="view-all-listings-btn"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    rel="noopener noreferrer"
                />
            </div>
        </div>
    </div>
    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import util from "@/common/util";
import Core from '../index';
import list from '../list.js';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import house from './house.vue';
export default {
    mixins: [Core, list],
    components: {
        house,
        Swiper,
        Slide: SwiperSlide
    },
    data() {
        return {
            isFixed: false,
            atEdge: false,
            lastScrollTop: 0,
            scrollDirection: 0,
        }    
    },
    computed: {
        layout11Fixed() {
            return {
                fixed: this.isFixed && !this.atEdge
            }
        },
        swiperOption({ isMobile }) {
            let defaultSwiperOption = {
                direction: 'vertical',
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                loop: false,
                autoplay: false,
                pagination: false,
                navigation: false,
                grabCursor: true,
                effect: 'creative',
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, '-20%', -1],
                    },
                    next: {
                        translate: [0, '100%', 0],
                    },
                },
            };
            if (!util.inCms) {
                defaultSwiperOption.mousewheel = {
                    eventsTarget: '.md-house',
                    closest: '.md-house',
                    stopScroll: this.stopScroll,
                    releaseOnEdges: true
                }
            }
            if (isMobile) {
                return {};
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        }
    }, 
    methods: {
        onSwiperChange(swiper) {
            this.atEdge = swiper.isBeginning || swiper.isEnd;
        },
        onSwiperReady(swiper) {
            this.pcSwiper = swiper;
            swiper.on('slideChange', () => {
                this.onSwiperChange(swiper);
            });

            this.onSwiperChange(swiper);
        },
        isEnScroll(direction) {
            const swiper = this.pcSwiper;
            let layout11Dom = this.$refs.houseLayout11;
            let rect = layout11Dom.getBoundingClientRect();
            // console.log('isEnScroll-----', direction, rect.top, swiper.isEnd, swiper.isBeginning)
            if (direction < 0) {
                // console.log('Slide up')
                if (swiper.isEnd) {
                    this.isFixed = false;
                    return true;
                }
                if (rect.top > 100) {
                    this.isFixed = true;
                    return false;
                }
            } else {
                // console.log('Slide down')
                if (swiper.isBeginning) {
                    this.isFixed = false;
                    return true;
                }
                if (rect.top < 100) {
                    this.isFixed = true;
                    return false;
                }
            }
            return true
        },
        stopScroll(newEvent, swiper) {
            if (this.isMobile) {
                return false; 
            }
            if (this.isEnScroll(newEvent.direction)) {
                return false;
            } else {
                return true;
            }
        },
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-house.layout11 {
    width: 100%;
    height: 840px;
    position: relative; 
    &.md-empty {
        height: unset;
    }
    .house-container.fixed {
        position: fixed;
        top: 100px;
        z-index: 100;
    }
    .house-list {
        width: 100%;
        height: 670px;
        .pc-swiper {
            height: 100%; 
            overflow: hidden;
        }
        .swiper-slide {
            height: 100%;
            background: #FFFFFF;
        }
    }

    .btn-wrap {
        background-color: var(--g-primary-color);
        padding: 60px 0;
        text-align: center;
        .view-all-listings-btn {
            box-sizing: border-box;
            display: inline-block;
            min-width: 200px;
            height: 50px;
            padding: 15px;
            font-size: 16px;
            font-family: var(--font-medium);
            background: none;
            border: 1px solid var(--g-btn-background);
            color: var(--g-btn-background);
            text-decoration: none;
            text-transform: uppercase;
        }
    }

    @include media-800 {
        height: auto;
        .house-container {
            position: static;
        }
        .house-title {
            margin-top: 40px;
            margin-bottom: 20px;
        }
        .house-list {
            height: auto;
            .mobile-list {
                height: 100%;
                .house-item:nth-child(n + 7) {
                    display: none;
                }
            }
        }
        .btn-wrap {
            padding: 30px 0;
        }
    }
}
</style>
